module.exports = __webpack_public_path__ + "img/mono-rounded.1d9137f3.svg";